import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const noconformidadService = {
  InsertOrUpdate,
  GetAll,
  Delete,
  getconformidadById,
}

async function InsertOrUpdate(body) {
  return await ApiBudgety.post('NoConformidades/InsertOrUpdate', body, {
    headers: {
      ACCION: MenusSistema.salidas_no_conformes.accesos.crear_editar_salida_no_conforme,
      MENU: MenusSistema.salidas_no_conformes.id,
    },
  })
}

async function GetAll(body) {
  return await ApiBudgety.post('NoConformidades/GetAll', body, {
    headers: {
      ACCION: MenusSistema.salidas_no_conformes.accesos.listar_salidas_no_conformes,
      MENU: MenusSistema.salidas_no_conformes.id,
    },
  })
}

async function Delete(id) {
  return await ApiBudgety.post('NoConformidades/Delete/' + id, {
    headers: {
      ACCION: MenusSistema.salidas_no_conformes.accesos.crear_editar_salida_no_conforme,
      MENU: MenusSistema.salidas_no_conformes.id,
    },
  })
}

async function getconformidadById(id) {
  return await ApiBudgety.get('NoConformidades/FindById/' + id, {
    headers: {
      ACCION: MenusSistema.salidas_no_conformes.accesos.listar_salidas_no_conformes,
      MENU: MenusSistema.salidas_no_conformes.id,
    },
  })
}
